import { render, staticRenderFns } from "./competitions.vue?vue&type=template&id=056039e8&"
import script from "./competitions.vue?vue&type=script&lang=js&"
export * from "./competitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports